import type { AvatarItem, MenuItems } from "./src/types/types";
import type { ThemeName } from "@repo/tokens";

export const themeMap: Record<number, ThemeName> = {
  1: "learn",
  2: "sriChaitanya",
  3: "meta",
  4: "meta",
  5: "sriChaitanya",
};

export const TERMS_URL =
  (import.meta.env.VITE_TERMS_URL as string | undefined) ??
  "https://terms.infinitylearn.com";
export const PRIVACY_URL =
  (import.meta.env.VITE_PRIVACY_URL as string | undefined) ??
  "https://privacy.infinitylearn.com";

export const AVATAR_ITEMS: AvatarItem[] = [
  { id: 1, label: "My Profile" },
  { id: 2, label: "Switch Profile" },
  { id: 3, label: "Switch Product" },
];

export const EMOJIS = ["👍", "👎", "👏", "😄", "😔"];

export const INDIAN_STATES = [
  { label: "Jammu and Kashmir", value: "JK", id: 1 },
  { label: "Himachal Pradesh", value: "HP", id: 2 },
  { label: "Punjab", value: "PB", id: 3 },
  { label: "Chandigarh", value: "CH", id: 4 },
  { label: "Uttarakhand", value: "UT", id: 5 },
  { label: "Haryana", value: "HR", id: 6 },
  { label: "Delhi", value: "DL", id: 7 },
  { label: "Rajasthan", value: "RJ", id: 8 },
  { label: "Uttar Pradesh", value: "UP", id: 9 },
  { label: "Bihar", value: "BR", id: 10 },
  { label: "Sikkim", value: "SK", id: 11 },
  { label: "Arunachal Pradesh", value: "AR", id: 12 },
  { label: "Nagaland", value: "NL", id: 13 },
  { label: "Manipur", value: "MN", id: 14 },
  { label: "Mizoram", value: "MZ", id: 15 },
  { label: "Tripura", value: "TR", id: 16 },
  { label: "Meghalaya", value: "ML", id: 17 },
  { label: "Assam", value: "AS", id: 18 },
  { label: "West Bengal", value: "WB", id: 19 },
  { label: "Jharkhand", value: "JH", id: 20 },
  { label: "Odisha", value: "OR", id: 21 },
  { label: "Chhattisgarh", value: "CG", id: 22 },
  { label: "Madhya Pradesh", value: "MP", id: 23 },
  { label: "Gujarat", value: "GJ", id: 24 },
  { label: "Dadra and Nagar Haveli", value: "DN", id: 25 },
  { label: "Daman and Diu", value: "DD", id: 26 },
  { label: "Maharashtra", value: "MH", id: 27 },
  { label: "Karnataka", value: "KA", id: 29 },
  { label: "Goa", value: "GA", id: 30 },
  { label: "Lakshadweep", value: "LD", id: 31 },
  { label: "Kerala", value: "KL", id: 32 },
  { label: "Tamil Nadu", value: "TN", id: 33 },
  { label: "Puducherry", value: "PY", id: 34 },
  { label: "Andaman and Nicobar Islands", value: "AN", id: 35 },
  { label: "Telangana", value: "TG", id: 36 },
  { label: "Andhra Pradesh", value: "AP", id: 37 },
] as const;

export type IndianState = (typeof INDIAN_STATES)[number];

export const allProfileIcons = [
  "avatar_boy_07_variant_3",
  "avatar_secondary_03",
  "avatar_secondary_04",
  "avatar_secondary_02",
  "avatar_girl_08_variant_3",
  "avatar_girl_14_variant_7",
  "avatar_boy_07_variant_3_alt",
  "avatar_girl_06_variant_2",
  "avatar_secondary_01",
  "avatar_boy_10_variant_4",
  "avatar_girl_13_variant_6",
  "avatar_boy_04_variant_2",
] as const;

export const MENU_ITEMS: MenuItems[] = [
  {
    id: "home",
    label: "Home",
    icon: "homeIcon",
    visible: true,
    height: 20,
    width: 17,
    sidebarIcon: "HomeIcon",
    sidebarIconWidth: 20,
    sidebarIconHeight: 17,
    showDivider: false,
  },
  {
    id: "live-classes",
    label: "Live Classes",
    icon: "live_Classes",
    visible: true,
    height: 20,
    width: 20,
    sidebarIcon: "LiveClassesIcon",
    sidebarIconWidth: 20,
    sidebarIconHeight: 20,
    showDivider: false,
  },
  {
    id: "learn",
    label: "Learn",
    icon: "learn",
    visible: true,
    height: 25,
    width: 22,
    sidebarIcon: "LearnIcon",
    sidebarIconWidth: 22,
    sidebarIconHeight: 19.5,
    showDivider: false,
  },
  {
    id: "tests",
    label: "Tests",
    icon: "tests",
    visible: true,
    height: 18,
    width: 20,
    sidebarIcon: "TestsIcon",
    sidebarIconWidth: 20.18,
    sidebarIconHeight: 16.07,
    showDivider: false,
  },
  {
    id: "Doubts",
    label: "Doubts",
    icon: "Doubts",
    visible: true,
    height: 21,
    width: 20,
    sidebarIcon: "DoubtsIcon",
    sidebarIconWidth: 20,
    sidebarIconHeight: 20,
    showDivider: true,
  },
  {
    id: "bookmarks",
    label: "My Bookmarks",
    icon: "bookmarks",
    visible: true,
    height: 26,
    width: 25,
    sidebarIcon: "BookmarksIcon",
    sidebarIconWidth: 14,
    sidebarIconHeight: 18,
    showDivider: false,
  },
  {
    id: "Subscriptions",
    label: "Subscriptions",
    icon: "Subscriptions",
    visible: true,
    height: 21,
    width: 22,
    sidebarIcon: "SubscriptionsIcon",
    sidebarIconWidth: 20,
    sidebarIconHeight: 20,
    showDivider: true,
  },
  {
    id: "ReferEarn",
    label: "Refer and Earn",
    icon: "ReferEarn",
    visible: true,
    height: 20,
    width: 23,
    sidebarIcon: "ReferEarnIcon",
    sidebarIconWidth: 20,
    sidebarIconHeight: 14,
    showDivider: false,
  },
  {
    id: "contact_us",
    label: "Contact Us",
    icon: "contact_us",
    visible: true,
    height: 12,
    width: 25,
    sidebarIcon: "ContactUsIcon",
    sidebarIconWidth: 24,
    sidebarIconHeight: 8.86,
    showDivider: false,
  },
  {
    id: "log_out",
    label: "Log Out",
    icon: "log_out",
    visible: true,
    height: 19,
    width: 19,
    sidebarIcon: "LogOutIcon",
    sidebarIconWidth: 16.6,
    sidebarIconHeight: 15,
    showDivider: false,
  },
];
